<template>
  <div class="modul">
    <div class="modul-top">
      <div class="caidan-img">
        <img src="../../../assets/image/caidan.png" alt="菜单" />
      </div>
      <div class="caidan-title">设备列表</div>
    </div>
    <div class="modul-content">
      <!-- 查询 -->
      <div class="query-form">
        <el-form :inline="true" :model="form" ref="form">
          <el-form-item label="桥梁名称">
            <el-select
              v-model="bridgeName"
              @change="bridgeChange"
              filterable
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in bridgeData"
                :key="index"
                :label="item.bridgeName"
                :value="item.bridgeUuid"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备类型">
            <el-select
              v-model="equipmentType"
              @change="equipmentTypeChange"
              filterable
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in equipmentTypes"
                :key="index"
                :label="item.equipmentTypeName"
                :value="item.equipmentTypeUuid"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            ><el-button type="primary" @click="tableReq()"
              >查询</el-button
            ></el-form-item
          >
        </el-form>
        <el-form :inline="true">
          <el-form-item
            ><el-button @click="addVisibles = true"
              >新增</el-button
            ></el-form-item
          >
          <el-form-item>
            <el-button @click="onExport">导出</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-row>
        <el-col :span="4">
          <el-table
            class="tableStyle"
            height="calc(100vh - 350px)"
            border
            style="width: 100%"
            ref="singleTable"
            :data="bridgeDatas"
            highlight-current-row
            @current-change="handleCurrentChange"
            :header-cell-style="{background: '#FAFAFA', color: '#000000'}"
          >
            <!-- <el-table-column label="序号" align="center" type="index" width="50px"></el-table-column> -->
            <el-table-column
              prop="bridgeName"
              label="桥梁名称"
              align="center"
            ></el-table-column>
          </el-table>
        </el-col>
        <el-col :span="20">
          <el-table
            class="tableStyle"
            v-loading="loading"
            height="calc(100vh - 350px)"
            border
            style="width: 100%"
            :data="tableData"
            :header-cell-style="{background: '#FAFAFA', color: '#000000'}"
          >
            <el-table-column
              label="序号"
              align="center"
              type="index"
              width="50px"
            ></el-table-column>
            <!-- <el-table-column prop="bridgeName" label="桥梁" align="center"></el-table-column> -->
            <el-table-column
              prop="equipmentAnotherName"
              label="设备别名"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="equipmentTypeName"
              label="设备类型"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="dataTypeName"
              label="数据类型"
              align="center"
            ></el-table-column>
            <el-table-column prop="name3" label="预警值" align="center">
              <template #default="scope">
                <div class="warning-value">
                  <div id="">{{ scope.row.beginWarningValue }}</div>
                  <div class="input-line"></div>
                  <div id="">{{ scope.row.endWarningValue }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="offlineCount"
              label="离线次数"
              align="center"
            ></el-table-column>
            <el-table-column prop="status" label="状态" align="center">
              <template #default="scope">
                <div
                  v-if="scope.row.status == 0"
                  style="color: #666"
                  class="zhuangtai"
                >
                  <div
                    style="
                      width: 5px;
                      height: 5px;
                      border-radius: 50%;
                      background: #d8d8d8;
                      margin-right: 5px;
                    "
                  ></div>
                  <div>离线</div>
                </div>
                <div
                  v-if="scope.row.status == 1"
                  class="zhuangtai"
                  style="color: #30bb4c"
                >
                  <div
                    style="
                      width: 5px;
                      height: 5px;
                      border-radius: 50%;
                      background: #30bb4c;
                      margin-right: 5px;
                    "
                  ></div>
                  <div>在线</div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <!--  -->
          <!-- <div style="text-align:center;margin: 20px 0 0;">
					  	<el-pagination @size-change="handleSizeChange" :hide-on-single-page="!total"
					  		@current-change="handleCurrentChange" :current-page="form.pageNum"
					  		:page-sizes="[10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000]" :page-size="form.pageSize"
					  		layout="total, sizes, prev, pager, next, jumper" :total="total">
					  	</el-pagination>
					  </div> -->
        </el-col>
      </el-row>
    </div>
    <!-- 桥梁信息详情 -->
    <el-dialog
      :modal-append-to-body="false"
      :visible.sync="addVisibles"
      width="75%"
      @close="guanbi()"
      :close-on-click-modal="false"
    >
      <div class="div-content">
        <div class="btn-add">
          <el-button size="mini" @click="add">新增</el-button>
          <el-select
            style="margin-left: 20px"
            v-model="bridgeUuid"
            @change="bridgeUuidChange"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in bridgeData"
              :key="index"
              :label="item.bridgeName"
              :value="item.bridgeUuid"
            ></el-option>
          </el-select>
        </div>
        <!-- 表格 -->
        <el-table
          :data="tableDataList"
          max-height="600"
          border
          height="480"
          style="width: 100%"
          :header-cell-style="{'text-align': 'center'}"
          :cell-style="{'text-align': 'center'}"
        >
          <el-table-column type="index" label="编号" width="60px" />
          <el-table-column
            prop="equipmentName"
            min-width="150px"
            label="设备名称"
          >
            <template #default="scope">
              <el-input
                v-model="scope.row.equipmentName"
                :disabled="scope.row.btnText"
                placeholder="请输入内容"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="equipmentAnotherName"
            min-width="150px"
            label="设备别名"
          >
            <template #default="scope">
              <el-input
                v-model="scope.row.equipmentAnotherName"
                :disabled="scope.row.btnText"
                placeholder="请输入内容"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="equipmentCode"
            label="设备编码"
            min-width="150px"
          >
            <template #default="scope">
              <el-input
                v-model="scope.row.equipmentCode"
                :disabled="scope.row.btnText"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="sim" label="SIM卡号" min-width="150px">
            <template #default="scope">
              <el-input
                v-model="scope.row.sim"
                :disabled="scope.row.btnText"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="dtuId" label="dtuId">
            <template #default="scope">
              <el-input
                v-model="scope.row.dtuId"
                :disabled="scope.row.btnText"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="channelCount" label="通道总数">
            <template #default="scope">
              <el-input
                v-model="scope.row.channelCount"
                :disabled="scope.row.btnText"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="modelId" label="设备模块号">
						<template #default="scope">
							<el-input v-model="scope.row.modelId" :disabled="scope.row.btnText" placeholder="请输入"></el-input>
						</template>
					</el-table-column> -->
          <el-table-column prop="sim" label="预警值" min-width="250px">
            <template #default="scope">
              <div class="warning-value">
                <el-input
                  v-model="scope.row.beginWarningValue"
                  :disabled="scope.row.btnText"
                  placeholder="请输入"
                ></el-input>
                <div class="input-line"></div>
                <el-input
                  v-model="scope.row.endWarningValue"
                  :disabled="scope.row.btnText"
                  placeholder="请输入"
                ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="equipmentTypeUuid"
            label="设备类型"
            min-width="120px"
          >
            <template #default="scope">
              <el-select
                filterable
                v-model="scope.row.equipmentTypeUuid"
                v-if="!scope.row.btnText"
                placeholder="请选择"
                @change="quipmentTypeChange($event, scope.row, scope.$index)"
              >
                <el-option
                  v-for="item in options"
                  :key="item.equipmentTypeId"
                  :label="item.equipmentTypeName"
                  :value="item.equipmentTypeUuid"
                ></el-option>
              </el-select>
              <el-input
                v-model="scope.row.equipmentTypeName"
                v-else
                disabled
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="communicationChannel"
            label="通讯通道"
            min-width="100px"
          >
            <template #default="scope">
              <el-input
                v-model="scope.row.communicationChannel"
                :disabled="scope.row.btnText"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="isEnable" label="是否启用" min-width="100px">
            <template #default="scope">
              <el-switch
                v-model="scope.row.isEnable"
                :disabled="scope.row.btnText"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="80px">
            <template #default="scope">
              <div
                :class="
                  scope.row.status == 0
                    ? ''
                    : scope.row.status == 1
                    ? 'isStatus'
                    : 'isRed'
                "
                class="default-status"
              >
                <div
                  :class="
                    scope.row.status == 0
                      ? ''
                      : scope.row.status == 1
                      ? 'isCircle'
                      : 'isRedle'
                  "
                  class="circle-div"
                ></div>
                <div>
                  {{
                    scope.row.status == 0
                      ? '离线'
                      : scope.row.status == 1
                      ? '在线'
                      : '未检测到状态'
                  }}
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column label="操作" width="80px" fixed="right">
            <template #default="scope">
              <div>
                <el-button
                  type="text"
                  v-if="!scope.row.equipmentId"
                  @click="sheBeiPeiZhiBC()"
                  >{{ scope.row.btnText ? '编辑' : '保存' }}</el-button
                >
                <el-button
                  type="text"
                  v-if="scope.row.equipmentId"
                  @click="bianJi(scope.row, scope.$index)"
                  >{{ scope.row.btnText ? '编辑' : '保存' }}</el-button
                >
                <el-button
                  type="text"
                  style="color: red"
                  v-if="scope.row.equipmentId"
                  @click="shanChu(scope.$index, tableData)"
                  >删除</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="anniu">
        <el-button type="primary" @click="guanbi()">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'DeqingBridgeAndTunnelShebeiliebiao',

  data() {
    return {
      form: {
        bridgeName: '',
        bridgeUuid: '',
        pageNum: 1,
        pageSize: 99999
      },
      loading: false,
      tableData: [],
      total: 0,
      bridgeData: [],
      bridgeDatas: [],
      equipmentTypes: [],
      equipmentType: '',
      bridgeName: '',
      addVisibles: false,
      tableDataList: [],
      bridgeUuid: ''
    }
  },

  async mounted() {
    this.getBiEquipmentType()
    await this.getBiBridgeBoPage()
    this.tableReq()
  },

  methods: {
    getParams() {
      if (this.bridgeData && this.bridgeData.length > 0) {
        if (this.form.bridgeUuid != '') {
          let add = this.bridgeData.find((item) => {
            return this.form.bridgeUuid == item.bridgeUuid
          })
          console.log(add)
          this.form.bridgeName = add.bridgeName
        } else {
          this.form.bridgeName = ''
        }
      }
      let data = {
        pageSize: 99999,
        pageNum: 1,
        bridgeName: this.form.bridgeName,
        bridgeUuid: this.form.bridgeUuid,
        equipmentTypeUuid: this.equipmentTypeUuid
      }
      return data
    },
    async tableReq() {
      this.loading = true
      let data = this.getParams()
      console.log(data)
      this.loading = false
      const res = await this.$api.sendPost('/biBridge/getBiBridgeTree', data)
      console.log(res)
      if (res.errcode == 0) {
        if (res.data && res.data.list.length > 0) {
          this.bridgeDatas = [...res.data.list]
          this.$refs.singleTable.setCurrentRow(this.bridgeDatas[0])
          if (this.equipmentTypeUuid) {
            this.tableData = this.bridgeDatas[0].equipmentList.filter(
              (item) => item.equipmentTypeUuid === this.equipmentTypeUuid
            )
          }
        } else {
          this.bridgeDatas = []
        }
      }
    },
    // // 分页器----新每页条数
    // handleSizeChange(val) {
    // 	this.form.pageSize = val;
    // 	this.tableReq(1);
    // },
    // // 分页器-----新当前页
    // handleCurrentChange(val) {
    // 	this.form.pageNum = val;
    // 	this.tableReq();
    // },
    // 设备类型选择
    async equipmentTypeChange(e) {
      this.equipmentTypeUuid = e
    },
    // 获取-桥梁名称列表
    async getBiBridgeBoPage() {
      let data = {
        pageSize: 99999,
        pageNum: 1
      }
      const res = await this.$api.sendPost('/biBridge/getBiBridgeBoPage', data)
      console.log('桥梁名称', res)
      if (res.errcode == 0) {
        if (res.data && res.data.list.length > 0) {
          this.bridgeData = [...res.data.list]
        } else {
          this.bridgeData = []
        }
      }
    },
    // 获取-桥梁名称列表
    async onExport() {
      let data = this.getParams()
      const res = await this.$api.sendDownload('/biBridge/export', data)
      let fileName = '设备列表'
      let blobObject = new Blob([res], {
        type: 'application/vnd.ms-excel,charset=utf-8'
      }) //如果是字节流
      //是IE浏览器
      if (!!window.ActiveXObject || 'ActiveXObject' in window) {
        window.navigator.msSaveOrOpenBlob(blobObject, fileName)
      } else {
        //火狐谷歌都兼容
        //模板中要有一个预定义好的a标签
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(blobObject) //如果是字节流
        link.target = '_blank'
        link.download = fileName
        link.click()
        //释放内存
        window.URL.revokeObjectURL(link.href)
      }
    },
    // 桥梁名称选择
    async bridgeChange(e) {
      this.form.bridgeUuid = e
      this.form.bridgeName = ''
      this.equipmentType = ''
      // console.log(this.form);
      // /biBridge/getEquipmentByBiBridgeAndEquipmentTypeUuid
      // /biBridge/getBridgeEquipmentTypeScreenList
      const res = await this.$api.sendGet(
        '/biBridge/getBridgeEquipmentTypeScreenList',
        {
          bridgeUuid: e
        }
      )
      console.log('设备类型', res)
      if (res.errcode === 0) {
        this.equipmentTypes = res.data
        this.equipmentType = ''
      } else {
        this.equipmentTypes = []
        this.equipmentType = ''
      }
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    },
    handleCurrentChange(val) {
      console.log(val)
      if (val.equipmentList && val.equipmentList.length > 0) {
        this.tableData = val.equipmentList
      } else {
        this.tableData = []
      }
    },
    guanbi() {
      this.addVisibles = false
    },
    // 判断是否是修改操作
    isUpdate() {
      return global.isUpdate ? true : false
    },
    // 设备类型选择
    quipmentTypeChange(e, row, index) {
      this.options.map((item) => {
        if (item.equipmentTypeUuid === e) {
          row.equipmentTypeUuid = item.equipmentTypeUuid
          row.equipmentTypeName = item.equipmentTypeName
        }
      })
      console.log(e)
      console.log(row)
      console.log(index)
    },
    // 保存
    async sheBeiPeiZhiBC() {
      let newArry = []
      const data = JSON.parse(JSON.stringify(this.tableDataList))
      data.map((item, index) => {
        item.isEnable = item.isEnable ? 0 : 1
        item.bridgeUuid = this.bridgeUuid
        if (!item.btnText) {
          console.log(item)
          newArry.push(Object.assign({}, data[index]))
        }
      })
      console.log(newArry)
      const res = await this.$api.sendPost('/biBridge/saveEquipment', newArry)
      if (res.errcode == 0) {
        this.$message.success(res.errmsg)
        await this.getBiBridgeBoPage()
        this.bridgeUuidChange(this.bridgeUuid)
        this.tableReq()
      } else {
        this.$message.error(res.errmsg)
      }
    },
    // 编辑
    async bianJi(row, index) {
      // true编辑 false保存
      row.btnText = !row.btnText
      this.$set(this.tableDataList, index, row)
      // this.tableDataList[index].btnText = !row.btnText;
      let isBc = row.btnText ? '编辑' : '保存'
      console.log(isBc)
      let data = JSON.parse(JSON.stringify(row))
      console.log(row)
      if (data.btnText) {
        data.isEnable = data.isEnable ? 0 : 1
        const res = await this.$api.sendPost('/biBridge/updateEquipment', data)
        if (res.errcode == 0) {
          row.btnText = true
          this.$message.success(res.errmsg)
        } else {
          row.btnText = false
          this.$message.error(res.errmsg)
        }
      }
      // 保存调用接口
      // if (isBc === '保存') {
      // 	data.isEnable = data.isEnable ? 0 : 1;
      // 	console.log(data);
      // 	const res = await this.$api.sendPost('/biBridge/updateEquipment', data);
      // 	if (res.errcode == 0) {
      // 		row.btnText = true;
      // 		this.$message.success(res.errmsg);
      // 	} else {
      // 		row.btnText = false;
      // 		this.$message.error(res.errmsg);
      // 	}
      // }
    },
    // 删除
    async shanChu(index, rows) {
      console.log(rows)
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          // 如果有设备类型uuid则调接口删除数据
          if (rows[index].equipmentUuid) {
            console.log(rows[index])
            const res = await this.$api.sendGet('/biBridge/deteleEquipment', {
              equipmentUuid: rows[index].equipmentUuid
            })
            if (res.errcode == 0) {
              // rows.splice(index, 1);
              this.tableDataList.splice(index, 1)
              await this.getBiBridgeBoPage()
              this.bridgeUuidChange(this.bridgeUuid)
              this.tableReq()
              this.$message.success(res.errmsg)
            } else {
              this.$message.error(res.errmsg)
            }
          } else {
            this.tableDataList.splice(index, 1)
            // rows.splice(index, 1);
            this.$message.success('删除成功')
          }
        })
        .catch(() => {
          this.$message.error('已取消操作')
        })
    },
    // 获取设备类型信息
    async getBiEquipmentType() {
      const res = await this.$api.sendPost(
        '/biEquipmentType/getBiEquipmentType',
        {
          pageSize: 99999,
          pageNum: 1
        }
      )
      if (res.errcode == 0) {
        this.options = res.data.list
      } else {
        this.options = []
      }
      console.log(res)
      console.log('获取设备类型信息', this.tableData)
    },
    // // 分页器----新每页条数
    // handleSizeChange(val) {
    // 	this.pagination.per_page = val;
    // 	// console.log(val);
    // 	this.click(0);
    // },
    // // 分页器-----新当前页
    // handleCurrentChange(val) {
    // 	this.pagination.current_page = val;
    // 	// console.log(val);
    // 	this.click();
    // },
    // 新增表格行
    add() {
      let obj = {
        bridgeUuid: '',
        equipmentName: '',
        equipmentCode: '',
        sim: '',
        dtuId: '',
        channelCount: '',
        // modelId: '',
        beginWarningValue: '',
        endWarningValue: '',
        equipmentTypeName: '',
        equipmentTypeUuid: '',
        communicationChannel: '',
        isEnable: false,
        status: 1,
        equipmentAnotherName: ''
      }
      if (!this.bridgeUuid) {
        this.$message.error('请先选择桥梁')
        return
      }
      this.tableDataList.push(obj)
    },
    /* 选择桥梁uuid */
    bridgeUuidChange(e) {
      this.bridgeUuid = e
      let info = this.bridgeData.find((item) => item.bridgeUuid == e)
      console.log('info.equipmentList', info, e)
      if (info.biEquipmentList && info.biEquipmentList.length > 0) {
        this.tableDataList = info.biEquipmentList.map((item) => {
          item.isEnable = !item.isEnable
          item.btnText = true
          return item
        })
        console.log('bridgeData', this.tableDataList)
      } else {
        this.tableDataList = []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.zhuangtai {
  display: flex;
  align-items: center;
  justify-content: center;
}

.warning-value {
  display: flex;
  align-items: center;
  justify-content: center;
}

.input-line {
  margin: 0 10px;
  width: 50px;
  border-bottom: 1px solid #999999;
}

.el-menu-vertical-demo {
  height: 600px;
}
</style>
<style lang="scss" scoped>
.div-content {
  padding: 0 10px;
  box-sizing: border-box;
  height: 700px;
  overflow: auto;

  .btn-add {
    display: flex;
    padding-bottom: 20px;
  }
}

.default-status {
  color: #666666;
  display: flex;
  align-items: baseline;
  justify-content: center;
}

.circle-div {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #d8d8d8;
  margin-right: 5px;
}

.isStatus {
  color: #30bb4c;
}

.isCircle {
  background-color: #30bb4c;
}

.isRed {
  color: #ff5722;
}

.isRedle {
  background-color: #ff5722;
}

.warning-value {
  display: flex;
  align-items: center;
}

.input-line {
  margin: 0 10px;
  width: 50px;
  border-bottom: 1px solid #999999;
}
</style>
